import { PageEyebrow } from '../components/PageContextLabel';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ErrorPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Unknown error');

  useEffect(() => {
    const errorMessage = searchParams.get('message');
    if (errorMessage) {
      setMessage(errorMessage);
    }
  }, [searchParams]);

  return (
    <div className="error-container">
      <div>
        <PageEyebrow section="Account" label="Authentication error" />
        <h1>Authentication Error</h1>
      </div>
      <p className="error-message">{message}</p>
      <button 
        onClick={() => navigate('/login')} 
        className="login-button"
      >
        Back to Login
      </button>
    </div>
  );
}
